import { IStatus } from "@/types";

const ListItemTypes = {
    code: 'code',
    text: 'text',
    date: 'date',
    route: 'route',
    boolean: 'boolean',
    number: 'number',
} as const;
export type IListItemType = keyof typeof ListItemTypes;

export type IListItem<T = any> = {
    label: string;
    value: T[keyof T] | string;
    itemType?: IListItemType;
    labelSlot?: string;
    valueSlot?: string;
    valueKey?: keyof T | string;
    hint?: string;
    isRequired?: boolean;
    isValid?: boolean;
    isClamp?: boolean;
    isHidden?: boolean;
    isFullWidthValue?: boolean;
    isShowTime?: boolean;
    isSeconds?: boolean;
    isCopyOnClick?: boolean;
    isScrollable?: boolean;
    isFormatJson?: boolean;
    isColumnOnMobile?: boolean;
    isHideLabel?: boolean;
    routeName?: string;
    routeText?: keyof T | string;
    query?: string[];
    additionalText?: keyof T | string;
    digits?: number;
    dateFormat?: 'dd.MM.yyyy' | 'dd MMMM yyyy';
    trueText?: string;
    falseText?: string;
    trueColor?: 'green';
    falseColor?: 'red';
    labelColor?: 'red' | 'green';
    color?: 'red' | 'green'
    isCopyTooltip?: boolean;
    status?: IStatus | ((i: T) => IStatus);
    template?: (i: string) => string;
    symbol?: string;
}

export type InfoCards<T> = {[key: string]: IListItem<T>[]};

export const usePrepareInfoCards = <T = object>(cards: InfoCards<any>, data: T ): InfoCards<T> => {
    const prepareFields = () => {
        for (const card of Object.values(cards)) {
            card.forEach((item) => {
                const key = item.valueKey! as keyof T;
                if (item.itemType === 'boolean') {
                    item.value = data[key] ?? '';
                } else {
                    item.value = `${data[key] ?? ''}`;
                }
            });
        }
    };

    const getCards = () => {
        prepareFields();
        for (let card of Object.values(cards)) {
            card = card.filter(item => item.value !== '');
        }
        return cards;
    };

    return getCards();
};
